<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useAuthRouteGuard } from '@/composables/useAuthRouteGuard'
import { useAppBadgePendingBookings } from '@/composables/useAppBadgePendingBookings'
import { useNavigate } from '@/composables/useNavigate'
import router from '@/router'
import LoadingScreen from '@/components/LoadingScreen.vue'
import { setLucideProps } from '@lucide/vue'

setLucideProps({
  strokeWidth: 1.4, // default Lucide: 2
  // size: 24,
  // color: 'currentColor',
  absoluteStrokeWidth: true,
  // class: 'my-icons',
})

const { canRenderRoute } = useAuthRouteGuard()
useAppBadgePendingBookings()

const { navigateTo } = useNavigate()
/** First navigation finished (includes async beforeResolve: Clerk, Convex, onboarding). */
const isRouterReady = ref(false)
void router.isReady().then(() => {
  isRouterReady.value = true
})
const DESKTOP_MIN_WIDTH = 768
const isDesktop = ref(false)

let devTapHandler: (() => void) | undefined
if (import.meta.env.DEV) {
  const TAP_WINDOW_MS = 300
  let tapCount = 0
  let lastTapTime = 0
  devTapHandler = () => {
    const now = Date.now()
    if (now - lastTapTime > TAP_WINDOW_MS) tapCount = 0
    tapCount++
    lastTapTime = now
    if (tapCount >= 5) {
      tapCount = 0
      navigateTo('/sitemap')
    }
  }
}

function checkViewport() {
  isDesktop.value = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`).matches
}

onMounted(() => {
  checkViewport()
  window.addEventListener('resize', checkViewport)
  if (devTapHandler) window.addEventListener('touchstart', devTapHandler)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkViewport)
  if (devTapHandler) window.removeEventListener('touchstart', devTapHandler)
})
</script>

<template>
  <div :class="$style.container">
    <!-- Auth shell gate: protected pages unmount the instant the session dies (no logged-out flash). -->
    <template v-if="!isRouterReady || !canRenderRoute">
      <LoadingScreen />
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<style module>
.desktop {
  width: 100%;
  background-image:
    linear-gradient(to bottom, #edd2e7 0%, #edd2e7 12%, transparent 22%), url('@/assets/background/colorful-v2.jpg');
  background-position:
    0 0,
    0 0;
  background-size:
    100% 100%,
    100% 100%;
  width: 100%;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  /* overflow: hidden; */
}
.container {
  /* background-color: red; */
  max-width: 480px;
  width: 100%;
  margin: 0 auto;

  height: 100%;
  position: relative;
  box-sizing: border-box;
  /* overflow: hidden; */
}
</style>
